import styled from 'styled-components';

export const VideoWrapper = styled.div`
    background-color: white;
    height: 338px;
    width: 600px;
`;
